import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	padding: 12px 16px;
`;

export const Card = styled.div`
	width: 100%;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.1);
	padding: 16px 20px;
	display: flex;
	flex-direction: ${ ( { $row } ) => $row ? 'row' : 'column' };
	justify-content: space-between;
	align-items: ${ ( { $row } ) => $row ? 'center' : 'stretch' };
	flex-wrap: wrap;
	gap: 16px;
`;

export const CardInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

export const TemplateName = styled.span`
	font-size: 16px;
	font-weight: 500;
	color: #111b21;
	font-family: monospace;
`;

export const Chips = styled.div`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
`;

export const Chip = styled.span`
	font-size: 12px;
	padding: 3px 10px;
	border-radius: 999px;
	background: #e9edef;
	color: #3b4a54;
`;

export const Field = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 320px;
	max-width: 100%;
`;

export const Label = styled.label`
	font-size: 13px;
	font-weight: 500;
	color: #111b21;
`;

export const Hint = styled.span`
	font-size: 12px;
	color: #667781;
`;

export const SectionTitle = styled.h3`
	font-size: 14px;
	font-weight: 600;
	margin: 0;
	color: #111b21;
`;

export const Select = styled.select`
	font-size: 13px;
	height: 36px;
	padding: 0 10px;
	border: 1px solid ${ ( { $missing } ) => $missing ? '#b45309' : '#d1d7db' };
	border-radius: 6px;
	background: #fff;
	color: #111b21;
	cursor: pointer;
	width: 100%;

	&:focus {
		outline: none;
		border-color: #00a884;
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;

export const ChatBackground = styled.div`
	background: #ece5dd;
	border-radius: 8px;
	padding: 20px;
	display: flex;
`;

export const Bubble = styled.div`
	background: #fff;
	border-radius: 8px;
	padding: 10px 14px;
	max-width: 620px;
	font-size: 14px;
	line-height: 1.7;
	color: #111b21;
	white-space: pre-wrap;
	word-wrap: break-word;
	box-shadow: 0 1px 1px rgba(0,0,0,0.12);
`;

export const Placeholder = styled.span`
	background: #d6f0e5;
	color: #0b4f3c;
	font-family: monospace;
	font-size: 13px;
	padding: 1px 6px;
	border-radius: 4px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.1);
	overflow: hidden;
`;

export const TableIntro = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 16px 20px 10px;
`;

export const TableHeader = styled.div`
	display: grid;
	grid-template-columns: 60px 1.2fr 1.6fr;
	gap: 12px;
	padding: 6px 20px;
	background: #e9edef;
	font-size: 11px;
	font-weight: 600;
	color: #54656f;
	text-transform: uppercase;
	letter-spacing: 0.5px;
`;

export const TableRow = styled.div`
	display: grid;
	grid-template-columns: 60px 1.2fr 1.6fr;
	gap: 12px;
	padding: 10px 20px;
	align-items: center;
	border-top: 1px solid #f0f2f5;
	background: ${ ( { $missing } ) => $missing ? '#fff8ec' : '#fff' };
`;

export const Order = styled.span`
	font-size: 13px;
	color: #667781;
`;

export const ParamName = styled.span`
	font-size: 13px;
	font-family: monospace;
	color: #111b21;
	word-break: break-all;
`;

export const ParamField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const MissingText = styled.span`
	font-size: 12px;
	color: #8a4b08;
`;

export const Warning = styled.div`
	width: 100%;
	font-size: 13px;
	color: #8a4b08;
	background: #fff8ec;
	border: 1px solid #f5d9a8;
	border-radius: 6px;
	padding: 10px 14px;
`;

export const StatusText = styled.span`
	font-size: 12px;
	color: #667781;
`;

export const Actions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
`;

export const CancelButton = styled.button`
	height: 36px;
	padding: 0 18px;
	font-size: 13px;
	border: 1px solid #d1d7db;
	border-radius: 6px;
	background: #fff;
	color: #111b21;
	cursor: pointer;

	&:hover {
		background: #f9fafb;
	}
`;

export const SaveButton = styled.button`
	height: 36px;
	padding: 0 18px;
	font-size: 13px;
	font-weight: 500;
	border: none;
	border-radius: 6px;
	background: #00a884;
	color: #fff;
	cursor: pointer;

	&:hover {
		background: #008f6f;
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;
